import App from './App.vue'
import {createApp} from 'vue'
import router from './router'
import store from './store'

import Oruga from '@oruga-ui/oruga-next'
import '@oruga-ui/oruga/dist/oruga-full-vars.css';

require('./assets/main.scss');
require('./assets/oruga-bulma.css');

import {library} from '@fortawesome/fontawesome-svg-core'

import {
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faSearch,
  faTimes,
  faPen,
  faTrash,
  faShieldAlt,
  faFolderPlus,
  faClone,
  faFileExport,
  faArrowLeft,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faSearch,
  faTimes,
  faPen,
  faTrash,
  faShieldAlt,
  faFolderPlus,
  faClone,
  faFileExport,
  faArrowLeft,
  faFileAlt
)


const app = createApp(App);

app.component('vue-fontawesome', FontAwesomeIcon);

app.use(Oruga, {
  iconPack: 'fas',
  iconComponent: 'vue-fontawesome',
  statusIcon: true,
  button: {
    rootClass: 'button',
    outlinedClass: () => {
      return 'is-outlined' // Outline class does not dependent on variants
    },
    disabledClass: 'btn-disabled',
    variantClass: 'is-'
  },
  field: {
    groupedClass: 'field--grouped',
    rootClass: 'field',
    labelClass: 'label',
    messageClass: 'form-text',
    variantClass: 'field-'
  },
  input: {
    inputClass: 'input',
    variantClass: 'is-',
    iconRightClass: 'input-icon-right'
  },
  icon: {
    variantClass: 'input-icon-'
  },
  dropdown: {
    rootClass: 'dropdown is-active',
    itemClass: 'dropdown-item',
    itemActiveClass: 'is-div-active'
  },
  steps: {
    itemHeaderActiveClass: 'steps-nav-item-active',
    itemHeaderPreviousClass: 'steps-nav-item-previous',
    stepMarkerClass: 'step-marker',
    stepDividerClass: 'step-divider',
  },
  checkbox: {
    override: true,
    rootClass: 'checkbox',
    labelClass: 'checkbox-label',
  },
});

app.use(router);
app.use(store);
app.mount('#app');

